import banner from "../../assets/img/banner.webp"
import banner2 from "../../assets/img/banner2.webp"
import banner3 from "../../assets/img/banner3.webp"
import bannerMobile from "../../assets/img/bannerMobile.webp"
import bannerMobile2 from "../../assets/img/bannerMobile2.webp"
import bannerMobile3 from "../../assets/img/bannerMobile3.webp"
import ourBanner from "../../assets/img/ourCompetenciesBanner.webp"
import gallery from "../../assets/img/galleryImg.webp"
import gallery2 from "../../assets/img/galleryImg2.webp"
import gallery3 from "../../assets/img/galleryImg3.webp"
import gallery4 from "../../assets/img/galleryImg4.webp"
import gallery5 from "../../assets/img/galleryImg5.webp"
import gallery6 from "../../assets/img/galleryImg6.webp"
import img from "../../assets/img/ourComBanner.webp";
import img2 from "../../assets/img/competen6.webp";
import img3 from "../../assets/img/competen7.webp";
import img4 from "../../assets/img/competen8.webp";
import processImg from "../../assets/img/processImg.webp"
import processImg2 from "../../assets/img/processImg2.webp"
import processImg3 from "../../assets/img/processImg3.webp"
import SvgServicesIcon from "../../assets/svg/SvgServicesIcon";
export const homeBanner = [
    {id: 1,img:banner,imgMobile: bannerMobile,item: "ИННОВАЦИИ"},
    {id: 2,img:banner2,imgMobile: bannerMobile2,item: "КАЧЕСТВО"},
    {id: 3,img:banner3,imgMobile: bannerMobile3,item: "ПРОФЕССИОНАЛИЗМ"},
]


export const PHONE_NUMBER = '+996555866070'

const WHATSAPP_NUMBER = '+996555866070'

const FOUNDER_WHATSAPP_NUMBER = '+996559692626'

const TELEGRAM_NICKNAME = '+996555866070'

const EMAIL_NAME = "prom_stal_kg@mail.ru"

const INSTAGRAM_NICKNAME = 'promstal.kg'

export const ADDRESS = 'https://2gis.kg/geo/70030076160669627/73.853603%2C42.791999'

/** не трогать!! **/
export const PHONE_NUMBER_LINK = `tel:${PHONE_NUMBER}`
export const EMAIL_LINK = `mailto:${EMAIL_NAME}`
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`
export const MOTION_WHATSAPP_LINK = `https://wa.me/${FOUNDER_WHATSAPP_NUMBER}`
export const TELEGRAM_LINK = `https://t.me/${TELEGRAM_NICKNAME}`
export const INSTAGRAM_LINK = `https://www.instagram.com/${INSTAGRAM_NICKNAME}/`


/** GalleryData **/
export const galleryStaticData = [
    {img:gallery},
    {img:gallery2},
    {img:gallery3},
    {img:gallery4},
    {img:gallery5},
    {img:gallery6},
]


/** OurCompetenciesData **/
export const staticData = [
    {img: ourBanner},
    {img: banner2},
]

export const staticDataTwo = [
    {img: img},
    {img: img2},
    {img: img3},
    {img: img4},
]

/** ServicesData **/
export const servicesStaticData = [
    {icon: <SvgServicesIcon/>, item: "Плазменная резка"},
    {icon: <SvgServicesIcon/>, item: "Пескоструйная очистка"},
    {icon: <SvgServicesIcon/>, item: "Закалка изделий"},
    {icon: <SvgServicesIcon/>, item: "Обработка металла на листогибе"},
    {icon: <SvgServicesIcon/>, item: "Приём металлолома"},
    {icon: <SvgServicesIcon/>, item: `Другая механическая\n обработка металлов`},
]

/** ProcessControlStaticData **/

export const ProcessStaticData = [
    {process: processImg},
    {process: processImg2},
    {process: processImg3},
]
